import { AVAILABLE_LANGUAGES } from '../../../constants';
/**
 * Generate flag URL with proper hash logic (matching FontLoader and TranslationService pattern)
 */
export const getFlagUrl = (assetsHost: string, assetsHash: string, langCode: string): string => {
  // For CDN environments, return empty string if hash is not available
  // This prevents requests without the hash in the path
  if (assetsHost.includes('cdn') && (!assetsHash || assetsHash === '')) {
    return '';
  }

  const isLocalhost = assetsHost.includes('localhost');
  const baseUrl = isLocalhost
    ? `${assetsHost}/assets/portal/flags/flag_${langCode.toLowerCase()}.svg`
    : `${assetsHost}${assetsHash ? '/' + assetsHash : ''}/assets/portal/flags/flag_${langCode.toLowerCase()}.svg`;
  return assetsHash && !isLocalhost ? `${baseUrl}?hash=${assetsHash}` : baseUrl;
};

/**
 * Language names mapping - use translations when available, fallback to static names
 */
export const getLanguageName = (code: string): string => {
    const languageNames: { [key: string]: string } = AVAILABLE_LANGUAGES;
    
    return languageNames[code.toUpperCase()] || code;
};
